<template>
    <div class="product-avatar">
        <div class="avatar-gray avatar-plr26">
            <div class="avatar-img-wrap">
                <img :src="step_img1" width="100%" />
            </div>
            <div class="avatar-title" style="margin-top: 22px;">
                AI数字分身-lawEos AI
            </div>
            <div class="avatar-title">
                构建全流程闭环
            </div>
            <div class="avatar-txt" style="margin-top: 18px;padding-bottom: 40px;">我们将AI Agent与数字名片相结合，为您量身打造了专属的AI数字分身——lawEos AI。它不仅是一款名片，更是一款「案源收割机」。全天候响应、精准筛选线索，助您高效开拓案源，实现案源转化。</div>
        </div>
        <div class="avatar-plr40 avatar-over">
            <div class="avatar-second-title avatar-pt60">
                AI法律顾问
            </div>
            <div class="avatar-desc avatar-pt17">永不疲倦的“律师助理”,7x24小时即时响应，秒回咨询，杜绝客户流失,引导式提问，梳理案情焦点，提供基础法律解析,自动结构化记录客户信息，为接案做足准备</div>
            <img class="avatar-img2" :src="step_img2" alt="">
        </div>
        <div class="avatar-gray avatar-plr40 avatar-over">
            <div class="avatar-second-title avatar-pt60">
                精准线索孵化器
            </div>
            <div class="avatar-desc avatar-pt17">从咨询到案源的智能转化,自动生成结构化线索报告：客户画像、案情摘要、核心诉求及法律预判一目了然</div>
            <img class="avatar-img3" :src="step_img3" alt="">
        </div>
        <div class="avatar-plr40 avatar-over">
            <div class="avatar-second-title avatar-pt60">
                数字名片
            </div>
            <div class="avatar-desc avatar-pt17">您的个人品牌专业展厅,集成形象、履历、擅长领域与经典案例展示专业文章，持续强化权威形象</div>
            <img class="avatar-img4" :src="step_img4" alt="">
        </div>

        <div>
            <nowdownload />
        </div>
        <Footer />
    </div>
</template>

<script>
import nowdownload from '@/components/nowdownload/index'
import { Footer} from '@/components'

function requireImg(str) {
    return require("pbimages/avatar/" + str);
}
export default {
    components:{
        nowdownload,
        Footer,
    },
    data() {
        return {
            step_img1: requireImg("step1.png"),
            step_img2: requireImg("step2.png"),
            step_img3: requireImg("step3.png"),
            step_img4: requireImg("step4.png"),
        };
    },
    created() {},
    methods: {},
};
</script>

<style lang="stylus" scoped>
.avatar-plr26{
    padding: 0 26px;
}
.avatar-plr40{
    padding: 0 40px;
}
.avatar-pt60{
    padding-top: 60px;
}
.avatar-pt17{
    padding-top: 17px;
}
.avatar-over{
    overflow: hidden;
}
.product-avatar{
    min-height: 100vh;
    background: #fff;
    overflow: hidden;
}
.avatar-gray{
    background: #f8f9fb;
}
.avatar-img-wrap{
    width: 608px;
    margin: 0 auto 0;
    padding-top: 70px;
}
.avatar-title{
    color: #303443;
    font-size: 38px;
    font-weight: bold;
    line-height: 54px;
    width: 390px;
    margin: 0 auto;
}
.avatar-txt{
    color: #5E606B;
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
}
.avatar-second-title{
    color: #303443;
    font-size: 33px;
    font-weight: 600;
}
.avatar-desc{
    color: #000000;
    font-weight: 400;
    font-size: 20px;
    line-height: 31px;
}
.avatar-img2{
    width: 645px;
    display: block;
    margin: 26px auto 60px;
}
.avatar-img3{
    width: 624px;
    display: block;
    margin: 38px auto 84px;
}
.avatar-img3{
    width: 624px;
    display: block;
    margin: 38px auto 84px;
}
.avatar-img4{
    width: 611px;
    display: block;
    margin: 21px auto 60px;
}
</style>
